import { useColorSchemeSync } from './color-scheme';

export function ColorSchemeSync() {
  useColorSchemeSync();
  return null;
}
